export default __webpack_public_path__ + "static/media/club-logo-hexagon.ef799ec0.svg";